import { render, staticRenderFns } from "./Echarts.vue?vue&type=template&id=4a513c74&scoped=true&"
import script from "./Echarts.vue?vue&type=script&lang=ts&"
export * from "./Echarts.vue?vue&type=script&lang=ts&"
import style0 from "./Echarts.vue?vue&type=style&index=0&id=4a513c74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a513c74",
  null
  
)

export default component.exports